@file:OptIn(InternalResourceApi::class)

package nastychristmas.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringArrayResource

private const val MD: String = "composeResources/nastychristmas.app.generated.resources/"

internal val Res.array.bad_words: StringArrayResource by lazy {
      StringArrayResource("string-array:bad_words", "bad_words", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 3179),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainArray0Resources(map: MutableMap<String, StringArrayResource>) {
  map.put("bad_words", Res.array.bad_words)
}
